export enum OrderChannel {
    QuickService = 1,
    TableService = 2,
    OnlineService = 3,
}
